"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginState = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const auth0_spa_js_1 = require("@auth0/auth0-spa-js");
const app_1 = require("app");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
const UserMenu_1 = require("./UserMenu");
const context_1 = require("../../context");
const typings_1 = require("../../typings");
require("@danfoss/mosaic/css/mosaic.css");
const LoginState = ({ mobile }) => {
    const { secondLevelData: { dipUserProfile, profileEditUrl, auth0Config }, dictionary, activePopup, setActivePopup, setIsSilentLogin, } = React.useContext(context_1.HeaderContext);
    const handleMenuExpand = () => {
        if (activePopup === typings_1.HeaderPopupEnum.UserInfo) {
            setActivePopup(null);
        }
        else {
            setActivePopup(typings_1.HeaderPopupEnum.UserInfo);
        }
    };
    React.useEffect(() => {
        const silentLogin = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const auth0 = new auth0_spa_js_1.Auth0Client({
                domain: auth0Config.auth0Domain,
                clientId: auth0Config.auth0ClientId,
            });
            try {
                const token = yield auth0.getTokenSilently();
                setIsSilentLogin(true);
                if (token && !dipUserProfile.isLoggedIn) {
                    globalThis.location.href = `/dip/silent-login/?returnUrl=${globalThis.location.pathname}`;
                }
            }
            catch (error) {
                if (dipUserProfile.isLoggedIn) {
                    globalThis.location.href = '/dip/logout/';
                }
            }
        });
        silentLogin();
    }, []);
    const onLoginHandler = React.useCallback((event) => {
        event.preventDefault();
        const urlPath = globalThis.location.pathname + encodeURIComponent(globalThis.location.search);
        globalThis.location.href = `/dip/login?returnUrl=${urlPath}`;
    }, []);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (!dipUserProfile.isLoggedIn && ((0, jsx_runtime_1.jsxs)("a", { className: (0, app_1.cn)('flex', mobile
                ? 'hover:bg-fill-primary-hovered p-xs active:bg-fill-primary-pressed rounded-full'
                : 'group pl-2xs pr-md  items-center relative text-icon-primary'), href: "/dip/login", "aria-controls": "login-dropdown", onClick: onLoginHandler, id: "login-link-desktop", children: [(0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "person-outline", className: (0, app_1.cn)('md:p-4xs md:mr-4xs group-hover:bg-fill-secondary-hovered group-active:bg-fill-secondary-pressed md:rounded-full') }), !mobile && (0, jsx_runtime_1.jsx)("span", { className: "font-body", children: dictionary.login })] }))) || ((0, jsx_runtime_1.jsxs)("div", { className: "relative", children: [(0, jsx_runtime_1.jsxs)("button", { className: (0, app_1.cn)(mobile
                        ? 'group hover:bg-fill-primary-hovered p-xs active:bg-fill-primary-pressed rounded-full'
                        : 'group md:pl-2xs md:pr-md items-center relative text-icon-primary', mobile && activePopup === typings_1.HeaderPopupEnum.UserInfo && 'bg-fill-secondary-pressed', 'flex relative'), onClick: handleMenuExpand, type: "button", id: "login-link-desktop", children: [mobile && activePopup === typings_1.HeaderPopupEnum.UserInfo ? ((0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "close", className: (0, app_1.cn)('md:p-4xs md:mr-4x rounded-full', !mobile &&
                                'group-hover:bg-fill-secondary-hovered group-active:bg-fill-secondary-pressed') })) : ((0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "person-outline", className: (0, app_1.cn)('md:p-4xs md:mr-4xs rounded-full', !mobile &&
                                'group-hover:bg-fill-secondary-hovered group-active:bg-fill-secondary-pressed', activePopup === typings_1.HeaderPopupEnum.UserInfo && 'bg-fill-secondary-pressed') })), !mobile && ((0, jsx_runtime_1.jsx)("span", { className: (0, app_1.cn)('font-body group-hover:underline underline-offset-3 decoration-[0.085em]', activePopup === typings_1.HeaderPopupEnum.UserInfo && 'underline'), children: dipUserProfile.data.initials }))] }), activePopup === typings_1.HeaderPopupEnum.UserInfo && ((0, jsx_runtime_1.jsx)(UserMenu_1.default, { dictionary: dictionary, userData: dipUserProfile.data, profileEditUrl: profileEditUrl }))] })) }));
};
exports.LoginState = LoginState;
